import * as React from 'react';

import { cn } from '@rematter/ui-web';

import { ModuleLayout } from '~/shared/layouts/ModuleLayout';
import { NavItem } from '~/shared/routing/createModuleNav';

type FacilitiesRootLayoutProps = {
  children: React.ReactNode;
  className?: string;
  moduleNavigation?: NavItem;
};

export const FacilitiesRootLayout = ({
  children,
  className,
  moduleNavigation,
}: FacilitiesRootLayoutProps) => (
  <ModuleLayout
    moduleNavigation={moduleNavigation}
    noContentPadding={true}
    className={cn('@FacilitiesRootLayout', className)}
  >
    {children}
  </ModuleLayout>
);
